(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("pathsToGroupsAssignments", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/assignments/pathsToGroupsAssignmentsView.html",
            controller: ["assignmentMapsResource", "authService", "messageService", "$localStorage", "$sessionStorage", "$timeout", "$scope", "$state", "$compile", "$translate", "$uibModal", "$sce", "DTOptionsBuilder", PathsToGroupsAssignmentsCtrl],
            controllerAs: "vm"
        };
        function PathsToGroupsAssignmentsCtrl(assignmentMapsResource, authService, messageService, $localStorage, $sessionStorage, $timeout, $scope, $state, $compile, $translate, $uibModal, $sce, DTOptionsBuilder) {
            var vm = this;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtInstance = {};
            if ($sessionStorage.managePathsToGroupsAssignmentsFilters) {
                vm.filters = $sessionStorage.managePathsToGroupsAssignmentsFilters;
            }
            else {
                vm.filters = {
                    pathName: { enabled: true, value: "" },
                    groupName: { enabled: true, value: "" }
                };
            }
            var tableReloading = false;
            var reloadTableTimeout;
            vm.reloadTable = function () {
                if (tableReloading) {
                    if (reloadTableTimeout)
                        $timeout.cancel(reloadTableTimeout);
                    reloadTableTimeout = $timeout(function () {
                        vm.reloadTable();
                    }, 200);
                }
                else {
                    tableReloading = true;
                    $timeout(function () {
                        $sessionStorage.managePathsToGroupsAssignmentsFilters = vm.filters;
                        vm.dtInstance.reloadData(function () {
                            tableReloading = false;
                        });
                        //If you want logging
                        //vm.dtInstance.reloadData(function (json) {
                        //	tableReloading = false;
                        //	console.log(json);
                        //});
                    });
                }
            };
            vm.refreshFilter = function (value) {
                $sessionStorage.managePathsToGroupsAssignmentsFilters = vm.filters;
                // reload only if filtered
                if (value.length > 0)
                    vm.dtInstance.reloadData();
            };
            vm.delete = function (id) {
                var modal = $uibModal.open({
                    templateUrl: "deleteRecordConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    assignmentMapsResource.delete({ id: id }, function () {
                        vm.dtInstance.reloadData();
                        messageService.success("common.recordDeleted");
                    }, function (error) {
                        vm.dtInstance.reloadData();
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            };
            vm.closeFilter = function (filter) {
                vm.filters[filter].enabled = false;
                vm.refreshFilter(vm.filters[filter].value);
            };
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withOption("ajax", {
                url: "api/assignmentMaps/paths-to-groups",
                error: function (error) {
                    if (error.status === 401) {
                        $state.go("main.signIn");
                    }
                    else if (error.status === 403) {
                        $state.go("main.accessDenied");
                    }
                },
                type: "GET",
                headers: {
                    Authorization: "Bearer " + authService.getToken(),
                    CurrentLocalizationId: $localStorage.currentLocalizationId
                },
                data: function (data) {
                    data.columns[0].search.value = vm.filters.pathName.enabled ? vm.filters.pathName.value : "";
                    data.columns[2].search.value = vm.filters.groupName.enabled ? vm.filters.groupName.value : "";
                }
            })
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withDataProp("data")
                .withOption("processing", true)
                .withOption("serverSide", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("createdRow", function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row))($scope);
            })
                .withPaginationType("full_numbers")
                .withBootstrap();
            vm.dtColumns = [
                { "data": "name" },
                {
                    "data": null,
                    "render": function (data, type, full) {
                        if (full.groupParentGroupId)
                            return "<a href='' class='group-full-path-name' data-group-id='" + full.groupId + "'>" + full.groupName + "</a>";
                        else
                            return full.groupName;
                    },
                    "sortable": false
                },
                {
                    "data": null,
                    "render": function (data, type, full) {
                        return "<button class='btn btn-xs btn-danger' ng-click='vm.delete(" + full.id + ")' translate='common.remove'></button>";
                    },
                    "sortable": false
                }
            ];
        }
    });
}());
